<template>
  <div>
    <!-- <template> -->
    <!-- <v-row justify="space-around"> -->
    <v-menu rounded="lg" offset-y>
      <template v-slot:activator="{ attrs, on }">
        <v-btn class="security-bookmark" v-bind="attrs" v-on="on" icon>
          <v-icon style="cursor: pointer"> mdi-bookmark-outline </v-icon>
          <!-- <v-icon>mdi-bookmark</v-icon>  -->
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="item in items" :key="item" link>
          <v-list-item-title></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- </v-row>
    </template> -->
  </div>
</template>

<script>
export default {
  name: "watchlistMenuComponent",
  data() {
    return {
      items: ["Watchlist 1", "Watchlist 2", "Watchlist 3"],
    };
  },
};
</script>

<style lang="scss" scoped></style>
